import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstantService } from "../providers/language.service";
import { Http, Response } from '@angular/http';
import { Router, NavigationStart } from '@angular/router';
import { NgForm } from '@angular/forms';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Observer } from 'rxjs/Observer';
import { Entity, Todo } from '../providers/entity';
import { Observable } from 'rxjs/Observable';
import { CustomerDetailsService } from '../Customerdashboard/customerdetails.service';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../providers/lang.service';
import { CustomCookieService } from '../providers/mycookie.service';
import { RestApiServices } from '../providers/rest.service';
import { AuthService } from '../auth.service';
import { LoaderComponent } from '../loader/loader.component';
import { CartitemsService } from '../providers/cartitems.service';
import { SharedServiceService } from '../shared/shared-service.service';
import { Constant } from '../Constant'
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['../app.component.css']

})
export class LoginComponent implements OnInit {
  @ViewChild('f') signupForm: NgForm;
  showloading: boolean = false;
  companyControl = new FormControl('', [Validators.required]);
  user = {
    username: '',
    password: '',
    company: ''
  };
  str: string;
  pass: string;
  submitted = false;
  match = true;
  error_message: string;
  companyId: string = "a"; userType: string = "webuser"; deviceId: string = "";
  token: any; login_data: Object; modules: any[]; color: any; selectedModule: any = null;
  cartItems = []; cartItemsCount = 0;
  defaultLaunguage: { languageName: string, languageId: string };
  IsHidden = true; title = 'app works!';
  buttonText: string = ""; forgot: string = ""; usrname: string = ""; pwd: string = ""; user_blank: string = "";
  pswd_blank: string = ""; invalid_paswd: string = ""; user_pswd_blank: string = ""; invalid_user: string = ""
  cmpny_blank: string = ""; lang_blank: string = ""; selectedCompany: any = 0;
  selectedLanguage: { languageName: string, languageId: any } = { languageName: 'EnglishUS', languageId: 0 };
  public languagesList: Array<{ languageName: string, languageId: string }>;
  public companiesList: Array<{ companyName: string, companyCode: string }>;
  public defaultcompany: { companyName: string, companyCode: string } = { companyName: "Select company", companyCode: null };
  language_key = Constant.KEY_CDISELECTEDLANGUAGE;
  prevRegion: any;

  constructor(private langService: LanguageService, private route: ActivatedRoute, private sharedService: SharedServiceService, private localCart: CartitemsService, private cookieService: CustomCookieService, private localStorage: CustomStorage,
    private languageservice: ConstantService, private http: Http, public router: Router, private customerdetailsService: CustomerDetailsService, private restApi: RestApiServices, private authService: AuthService, public entity: Entity) {
  }

  ngOnInit() {
    // Check for the various File API support.
    // if (window.webkitRequestAnimationFrame && window.Blob) {
    //   console.log( "Great success! All the File APIs are supported.")
    // } else {
    //   alert('The File APIs are not fully supported in this browser.');
    // }
    //   try {
    //     this.localStorage.setItem("test", 1).subscribe(res => {
    //       console.log(res + "its saving")
    //     })
    //     // console.log("works!!");
    // } catch (exception) {
    //     console.log('browser / mode not supported');
    // }
    // this.localStorage.emptyStorage();
    // this.cookieService.removieCokkieData()
    this.route.paramMap.map(params => params)
      .subscribe(params => {
        this.prevRegion = <any>params.get('region');
      });

    this.sharedService.removeAllData();
    LoaderComponent.loadingV.next(true);
    this.langService.getLanguageData().subscribe(data => {
      // LoaderComponent.loadingV.next(false);
      this.getLanguageLabels();
    }, error => {

    }, () => {

    });
  }


  onSubmit() {
    LoaderComponent.loadingV.next(true);
    this.submitted = true;
    this.user.username = this.signupForm.value.userData.username.username;
    // let company_name= this.user.username.charAt(0);
    this.user.password = this.signupForm.value.userData.password.password;
    // this.user.company = this.signupForm.value.userData.company;
    this.user.company = this.user.username.charAt(0);
    if (this.selectedLanguage.languageName == '') {
      this.error_message = this.lang_blank;
    }
    else if (this.user.username == '' && this.user.password != '') {
      this.error_message = this.user_blank;
    }
    else if (this.user.username != '' && this.user.password == '') {
      this.error_message = this.pswd_blank;
    }
    else if (this.user.username == '' && this.user.password == '') {
      this.error_message = this.user_pswd_blank;
    }
    // else if (this.user.company == '' || this.user.company == 'Select company') {
    //   this.error_message = this.cmpny_blank;
    // }
    else if (this.user.username != '' && this.user.password != '') {
      this.restApi.getLoginResponse(this.user.username, this.user.password, this.user.company).subscribe((data) => {
        let statusCode = data.response.status_code;
        this.error_message = data.response.error_message;
        LoaderComponent.loadingV.next(false);
        if (this.error_message.length === 0) {
          this.authService.login();
          this.getPaymentApiConfig();
          this.router.navigate(['/dashboard/customerdetails']);
        }


      }, error => {
        this.error_message = "Error in processing the data";
      });
    }
    else {
      this.match = false;
    }
  }


  getPaymentApiConfig() {
    this.restApi.getPaymentApiConfig(this.user.username).subscribe((data) => {
      if (data.response.onlineaccountinfo) {
        let accountIfo = data.response.onlineaccountinfo.online_account_info
        accountIfo.forEach(function (value, key) {
          if(value.provider_id == "1") {
            localStorage.setItem('AuthoriseConfigData', JSON.stringify(value));
            let authoriseConfig =  JSON.parse(localStorage.getItem('AuthoriseConfigData'));
            if(authoriseConfig.provider_account && authoriseConfig.provider_auth_key) {
              localStorage.setItem('PaymentMethodSetup', "yes");
            } else {
              localStorage.setItem('PaymentMethodSetup', "no");
            }
          } else {
            localStorage.setItem('PaymentMethodSetup', "no");
          }
        });
      }
    }, error => {
      this.error_message = "Error in processing the data";
    });
  }

  getLanguageLabels() {

    this.langService.getSelectedLanguage(this.prevRegion).subscribe(data => {
      if (data != undefined)
        this.selectedLanguage = data[0];

      this.langService.getAllLanguages().subscribe(languages => {
        this.languagesList = languages

        this.langService.getAllCompanies().subscribe(companies => {
          this.companiesList = companies;
          this.setLabels();
          //this.getLanguageLabels();

        });
      });

    });


  }

  setLabels() {

    this.langService.getLangLabel("LblLogIn").then(data => { this.buttonText = data; });
    this.langService.getLangLabel("LblUsername").then(data => this.usrname = data);
    this.langService.getLangLabel("LblPassword").then(data => this.pwd = data);
    this.langService.getLangLabel("LblForgotPwd").then(data => this.forgot = data);
    this.langService.getLangLabel("200_user_blank").then(data => this.user_blank = data);
    this.langService.getLangLabel("200_pswd_blank").then(data => this.pswd_blank = data);
    this.langService.getLangLabel("200_user_pswd_blank").then(data => this.user_pswd_blank = data);
    this.langService.getLangLabel("200_invalid_paswd").then(data => this.invalid_paswd = data);
    this.langService.getLangLabel("200_invalid_user").then(data => { this.invalid_user = data });
    this.langService.getLangLabel("200_cmpny_blank").then(data => { this.cmpny_blank = data });
    this.langService.getLangLabel("200_lang_blank").then(data => this.lang_blank = data);
  }

  public valueChange(language: any): void {
    this.langService.setLanguageData(language).then(data => {
      this.setLabels();
    });

  }


  public companyChange(company: any): void {
    this.user.company = company;
    this.languageservice.setCompany(company);
  }


  public result;

}



// WEBPACK FOOTER //
// ./src/app/Login/login.component.ts